import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { logout } from "../actions/auth"
import {
	PlickState,
	PlicksListState,
	fetchFileDetail,
	getFileDetail,
} from "../actions/file-detail"

const initialState: PlicksListState = {
	loading: false,
	loadingFetch: false,
	error: undefined,
	errorFetch: undefined,
	list: [],
}

const PlicksListSlice = createSlice({
	name: "plicks",
	initialState: initialState,
	reducers: {
		clearError: (state: PlicksListState) => {
			state.error = undefined
			state.loading = false
		},
		resetDefault: (state: PlicksListState) => {
			state.loading = false
			state.loadingFetch = false
			state.error = undefined
			state.errorFetch = undefined
			state.list = []
		},
		updatePatchForId: (
			state: PlicksListState,
			action: PayloadAction<{ id: number; updatedPlick: PlickState }>
		) => {
			const { id, updatedPlick } = action.payload
			const index = state.list.page.content.findIndex((f) => f.id === id)
			if (index !== -1) {
				state.list.page.content[index] = updatedPlick
			}
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(logout.fulfilled, () => initialState)
			.addCase(getFileDetail.pending, (state: PlicksListState) => {
				state.loading = true
				state.error = undefined
			})
			.addCase(
				getFileDetail.fulfilled,
				(state: PlicksListState, action: PayloadAction<PlickState[]>) => {
					state.loading = false
					state.error = undefined
					state.list = action?.payload
				}
			)
			.addCase(
				getFileDetail.rejected,
				(
					state: PlicksListState,
					action: PayloadAction<{ message: string }>
				) => {
					state.loading = false
					state.error = action?.payload?.message ?? "generic"
				}
			)
			.addCase(fetchFileDetail.pending, (state: PlicksListState) => {
				state.loadingFetch = true
				state.errorFetch = undefined
			})
			.addCase(
				fetchFileDetail.fulfilled,
				(state: PlicksListState, action: PayloadAction<PlickState[]>) => {
					state.loadingFetch = false
					state.errorFetch = undefined
					state.list = {
						nextUrl: action?.payload.nextUrl,
						page: {
							...action?.payload.page,
							content: [
								...state.list.page.content,
								...action?.payload.page.content,
							],
						},
					}
				}
			)
			.addCase(fetchFileDetail.rejected, (state: PlicksListState, action) => {
				state.loadingFetch = false
				state.errorFetch = action?.payload.message
			})
	},
})

export const { clearError, resetDefault, updatePatchForId } =
	PlicksListSlice.actions

export default PlicksListSlice.reducer
